import { Component, OnInit, Input } from '@angular/core'

@Component({
  standalone: false,
  selector: 'latitude-geo-logo-mini',
  templateUrl: './geo-logo-mini.component.html',
  styleUrls: ['./geo-logo-mini.component.scss'],
})
export class GeoLogoMiniComponent implements OnInit {
  @Input() size = 24
  @Input() showCarto = false

  constructor() {}

  ngOnInit() {}
}
